import request from "./request.js";
import { BASE_API, TOKEN_API, LOGIN_API, UPLOAD_API } from "./constant.js";
import { handleSuccess, handleError, disposeNologin } from "./helper.js";

/**
 * 通用 POST 请求
 */
export const post = (url, data, callback) => {
  request
    .post(url, data)
    .then((res) => handleSuccess(res, callback))
    .catch(handleError);
};

/**
 * 通用 GET 请求
 */
// export const get = (url, callback) => {
//   request
//     .get(url)
//     .then((res) => handleSuccess(res, callback))
//     .catch(handleError);
// };
export const get = (url, params, callback) => {
  // 兼容：如果 params 是函数，说明它是 callback，此时没有 params
  if (typeof params === "function") {
    callback = params;
    params = {};
  }

  const safeParams = params && typeof params === "object" ? params : {};
  return request
    .get(url, { params: safeParams })
    .then((res) => {
      handleSuccess(res, callback);
      return res;
    })
    .catch(handleError);
};

/**
 * 上传专用（multipart/form-data）
 */
export const upload = (url, data, callback) => {
  request
    .post(url, data, {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        token: localStorage.getItem("token"),
      },
    })
    .then((res) => {
      if (res.status === 200) {
        callback && callback(res);
      } else {
        // 根据后端返回格式调整判断方式
        const msg = res.data.msg || "上传失败";
        handleError({ message: msg });
      }
    })
    .catch(handleError);
};

/**
 * 统一请求入口（兼容旧逻辑）
 */
export const doRequest = (api, data, type = "POST", callback) => {
  const url = api; // 完整路径
  const token = localStorage.getItem("logintoken");

  // 判断是否需要 token
  if (TOKEN_API.includes(api) && !token) {
    disposeNologin();
    return;
  }

  // 上传接口特殊处理
  if (UPLOAD_API.includes(api)) {
    upload(url, data, callback);
    return;
  }

  // 普通请求
  if (type === "GET") {
    return get(url, data, callback);
  } else {
    return post(url, data, callback);
  }
};



// WEBPACK FOOTER //
// ./src/utils/api.js